import React from "react";
import { useTranslation } from "react-i18next";

import { LocationSearchBox } from "./LocationSearchBox";
import { PAGE_NUMBER_OPTIONS } from "../../../../config";
import ToggleBtns from "../../../ToggleBtns";
import { LocationActivityQueryParams } from "../types";

import "./styles.scss";

interface ILocationActivityTableControlsProps {
  value: LocationActivityQueryParams;
  onChange: (value: LocationActivityQueryParams) => void;
}

export const LocationActivityTableControls: React.FunctionComponent<
  ILocationActivityTableControlsProps
> = ({ value, onChange }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`locationActivityPage.${key}`);

  const handleLocationNameChange = (locationName: string) => {
    onChange({
      ...value,
      locationName,
    });
  };

  const handleNumberPerPageChange = (limit: number) => {
    onChange({
      ...value,
      limit: limit,
      offset: 0,
    });
  };

  return (
    <div className="location-activity-table-controls-top-bar">
      <div className="controls-group">
        <LocationSearchBox
          value={value.locationName}
          onChange={handleLocationNameChange}
        />
        <div className="per-page-toggle">
          <div className="number-of-logs-per-page-txt">
            {t("number_of_logs_per_page")}
          </div>
          <ToggleBtns
            selectedValue={value.limit || PAGE_NUMBER_OPTIONS[0]}
            options={PAGE_NUMBER_OPTIONS}
            onClickBtn={handleNumberPerPageChange}
          />
        </div>
      </div>
    </div>
  );
};
